import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useArchNode from '../_ARCH/useArchNode.jsx'
import meta from './metaBa.mjs'
import PropertiesPane from './PropertiesPaneBa.jsx'
import api from './apiBa.mjs'

export default () => {
    const ArchNode = useArchNode()

    return extendNode(ArchNode, {
        ...meta,
        api,
        PropertiesPane,

        getStyle(map, node) {
            const {subTypeCode} = map.data

            const backgroundColor = 'BODA1' === subTypeCode ?
                Color.LIGHT_YELLOW : Color.GOLD

            return this._getStyle(map, node, {backgroundColor})
        },

        getText(map, node) {
            const {mapTypeCode, prjTypeCode, subTypeCode} = map.data

            if ('SA_MAP' === mapTypeCode) {
                if (
                    'BM' === prjTypeCode ||
                    'BODA2' === subTypeCode
                ) {
                    return '能力模型'
                }
                else {
                    return {
                        BAM: '基准模型',
                        TAM: '主题模型',
                    }[prjTypeCode] ?? this.alias
                }
            }
            else {
                return ArchNode.getText.call(this, map, node)
            }
        },

        _pushDataSlots: {
            archBmList: [],
        },
    })
}
